import request from 'axios';
import { ActionCreators } from 'redux-undo';

export const PREV_TOUR = 'PREV_TOUR';
export const NEXT_TOUR = 'NEXT_TOUR';
export const TOURS_GET = 'TOURS_GET';
export const TOURS_GET_REQUEST = 'TOURS_GET_REQUEST';
export const TOURS_GET_SUCCESS = 'TOURS_GET_SUCCESS';
export const FEATURED_TOURS_GET = 'FEATURED_TOURS_GET';
export const FEATURED_TOURS_GET_REQUEST = 'FEATURED_TOURS_GET_REQUEST';
export const FEATURED_TOURS_GET_SUCCESS = 'FEATURED_TOURS_GET_SUCCESS';
export const POINTS_GET = 'POINTS_GET';
export const POINTS_GET_REQUEST = 'POINTS_GET_REQUEST';
export const POINTS_GET_SUCCESS = 'POINTS_GET_SUCCESS';
export const POINTS_GET_FAILURE = 'POINTS_GET_FAILURE';
export const SET_BOUNDED_OBJECTS = 'SET_BOUNDED_OBJECTS';
export const DESTINATION_GET = 'DESTINATION_GET';
export const DESTINATION_GET_REQUEST = 'DESTINATION_GET_REQUEST';
export const DESTINATION_GET_SUCCESS = 'DESTINATION_GET_SUCCESS';
export const DESTINATION_GET_FAILURE = 'DESTINATION_GET_FAILURE';
export const PROMO_GET = 'PROMO_GET';
export const PROMO_GET_REQUEST = 'PROMO_GET_REQUEST';
export const PROMO_GET_SUCCESS = 'PROMO_GET_SUCCESS';
export const PROMO_GET_FAILURE = 'PROMO_GET_FAILURE';
export const LANDMARK_GET = 'LANDMARK_GET';
export const LANDMARK_GET_REQUEST = 'LANDMARK_GET_REQUEST';
export const LANDMARK_GET_SUCCESS = 'LANDMARK_GET_SUCCESS';
export const LANDMARK_GET_FAILURE = 'LANDMARK_GET_FAILURE';
export const LANDMARKS_GET = 'LANDMARKS_GET';
export const LANDMARKS_GET_REQUEST = 'LANDMARKS_GET_REQUEST';
export const LANDMARKS_GET_SUCCESS = 'LANDMARKS_GET_SUCCESS';
export const LANDMARKS_GET_FAILURE = 'LANDMARKS_GET_FAILURE';
export const REVIEWS_GET = 'REVIEWS_GET';
export const REVIEWS_GET_REQUEST = 'REVIEWS_GET_REQUEST';
export const REVIEWS_GET_SUCCESS = 'REVIEWS_GET_SUCCESS';
export const REVIEWS_GET_FAILURE = 'REVIEWS_GET_FAILURE';
export const ALL_REVIEWS_GET = 'ALL_REVIEWS_GET';
export const ALL_REVIEWS_GET_REQUEST = 'ALL_REVIEWS_GET_REQUEST';
export const ALL_REVIEWS_GET_SUCCESS = 'ALL_REVIEWS_GET_SUCCESS';
export const ALL_REVIEWS_GET_FAILURE = 'ALL_REVIEWS_GET_FAILURE';
export const HOTELS_GET = 'HOTELS_GET';
export const HOTELS_GET_REQUEST = 'HOTELS_GET_REQUEST';
export const HOTELS_GET_SUCCESS = 'HOTELS_GET_SUCCESS';
export const HOTELS_GET_FAILURE = 'HOTELS_GET_FAILURE';
export const HOTEL_GET = 'HOTEL_GET';
export const HOTEL_GET_REQUEST = 'HOTEL_GET_REQUEST';
export const HOTEL_GET_SUCCESS = 'HOTEL_GET_SUCCESS';
export const HOTEL_GET_FAILURE = 'HOTEL_GET_FAILURE';
export const SELECT_PAGE = 'SELECT_PAGE';
export const PAGE_GET = 'PAGE_GET';
export const PAGE_GET_REQUEST = 'PAGE_GET_REQUEST';
export const PAGE_GET_SUCCESS = 'PAGE_GET_SUCCESS';
export const PAGE_GET_FAILURE = 'PAGE_GET_FAILURE';
export const GALLERY_GET = 'GALLERY_GET';
export const GALLERY_GET_REQUEST = 'GALLERY_GET_REQUEST';
export const GALLERY_GET_SUCCESS = 'GALLERY_GET_SUCCESS';
export const SERVICE_GALLERY_GET = 'SERVICE_GALLERY_GET';
export const SERVICE_GALLERY_GET_REQUEST = 'SERVICE_GALLERY_GET_REQUEST';
export const SERVICE_GALLERY_GET_SUCCESS = 'SERVICE_GALLERY_GET_SUCCESS';
export const SELECT_PHOTO = 'SELECT_PHOTO';
export const TYPES_GET = 'TYPES_GET';
export const TYPES_GET_REQUEST = 'TYPES_GET_REQUEST';
export const TYPES_GET_SUCCESS = 'TYPES_GET_SUCCESS';
export const ACTIVITIES_GET = 'ACTIVITIES_GET';
export const ACTIVITIES_GET_REQUEST = 'ACTIVITIES_GET_REQUEST';
export const ACTIVITIES_GET_SUCCESS = 'ACTIVITIES_GET_SUCCESS';
export const DESTINATIONS_GET = 'DESTINATIONS_GET';
export const DESTINATIONS_GET_REQUEST = 'DESTINATIONS_GET_REQUEST';
export const DESTINATIONS_GET_SUCCESS = 'DESTINATIONS_GET_SUCCESS';
export const DESTINATIONS_GET_FAILURE = 'DESTINATIONS_GET_FAILURE';
export const TOUR_GET = 'TOUR_GET';
export const SELECT_TOUR = 'SELECT_TOUR';
export const SELECT_MAP_TOUR = 'SELECT_MAP_TOUR';
export const ACTIVATE_MAP = 'ACTIVATE_MAP';
export const FIXED_MAP = 'FIXED_MAP';
export const SELECT_MAP_PHOTO = 'SELECT_MAP_PHOTO';
export const NEXT_MAP_PHOTO = 'NEXT_MAP_PHOTO';
export const PREV_MAP_PHOTO = 'PREV_MAP_PHOTO';
export const SELECT_DESTINATION = 'SELECT_DESTINATION';
export const SELECT_MAIN_DESTINATION = 'SELECT_MAIN_DESTINATION';
export const SELECT_TYPE = 'SELECT_TYPE';
export const SELECT_MAIN_TYPE = 'SELECT_MAIN_TYPE';
export const SELECT_SEASON = 'SELECT_SEASON';
export const SELECT_ACTIVITY = 'SELECT_ACTIVITY';
export const SELECT_MONTH = 'SELECT_MONTH';
export const SELECT_LANDMARK = 'SELECT_LANDMARK';
export const TOUR_GET_REQUEST = 'TOUR_GET_REQUEST';
export const TOUR_GET_SUCCESS = 'TOUR_GET_SUCCESS';
export const TOUR_GET_FAILURE = 'TOUR_GET_FAILURE';
export const SET_CENTER = 'CET_CENTER';
export const PREV_DAY = 'PREV_DAY';
export const NEXT_DAY = 'NEXT_DAY';
export const SELECT_DAY = 'SELECT_DAY';
export const TOGGLE_DAY = 'TOGGLE_DAY';
export const HOVER_DAY = 'HOVER_DAY';
export const SET_DAY_PHOTO_VISIBLE = 'SET_DAY_PHOTO_VISIBLE';
export const TOGGLE_CATEGORIES = 'TOGGLE_CATEGORIES';
export const SET_MAP_HEIGHT = 'SET_MAP_HEIGHT';
export const SET_MAP = 'SET_MAP';
export const SET_MAP_CONFIG = 'SET_MAP_CONFIG';
export const SET_MAP_FILTER = 'SET_MAP_FILTER';
export const SET_ZOOM = 'SET_ZOOM';
export const SET_ROUTE_DRAW = 'SET_ROUTE_DRAW';
export const TOGGLE_DEPARTURE = 'TOGGLE_DEPARTURE';
export const TOGGLE_VIEW_PHOTO = 'TOGGLE_VIEW_PHOTO';
export const SELECT_DEPARTURE = 'SELECT_DEPARTURE';
export const MORE_OBJECTS = 'MORE_OBJECTS';
export const SET_SCROLL = 'SET_SCROLL';
export const TOURS_SEARCH = 'TOURS_SEARCH';
export const TOURS_SEARCH_REQUEST = 'TOURS_SEARCH_REQUEST';
export const TOURS_SEARCH_SUCCESS = 'TOURS_SEARCH_SUCCESS';
export const TOURS_SEARCH_FAILURE = 'TOURS_SEARCH_FAILURE';
export const TOURS_SEARCH_BY_MODE = 'TOURS_SEARCH_BY_MODE';
export const TOURS_SEARCH_BY_MODE_REQUEST = 'TOURS_SEARCH_BY_MODE_REQUEST';
export const TOURS_SEARCH_BY_MODE_SUCCESS = 'TOURS_SEARCH_BY_MODE_SUCCESS';
export const TOURS_SEARCH_BY_MODE_FAILURE = 'TOURS_SEARCH_BY_MODE_FAILURE';
export const LOCATIONS_GET = 'LOCATIONS_GET';
export const LOCATIONS_GET_SUCCESS = 'LOCATIONS_GET_SUCCESS';
export const LOCATIONS_GET_REQUEST = 'LOCATIONS_GET_REQUEST';
export const SET_LOCATION = 'SET_LOCATION';
export const TOUR_MENU_GET = 'TOUR_MENU_GET';
export const TOUR_MENU_GET_SUCCESS = 'TOUR_MENU_GET_SUCCESS';
export const TOUR_MENU_GET_REQUEST = 'TOUR_MENU_GET_REQUEST';
export const SET_LOCATION_REQUEST = 'SET_LOCATION_REQUEST';
export const SELECT_TAB = 'SELECT_TAB';
export const TOGGLE_MAP_FILTER = 'TOGGLE_MAP_FILTER';
export const OPEN_REVIEW = 'OPEN_REVIEW';
export const OPEN_REVIEW_ANSWER = 'OPEN_REVIEW_ANSWER';
export const TOGGLE_REVIEW_RATE = 'TOGGLE_REVIEW_RATE';
export const OPEN_REVIEWS = 'OPEN_REVIEWS';
export const SELECT_REVIEWS_LANG = 'SELECT_REVIEWS_LANG';
export const PLAY_VIDEO = 'PLAY_VIDEO';
export const SWIPE_GALLERY = 'SWIPE_GALLERY';
export const TOGGLE_DESCRIPTION = 'TOGGLE_DESCRIPTION';
export const CLEAR_ROUTE = 'CLEAR_ROUTE';





let apiUrl = '';
let mode = 'production';
let cdnApi = {};

if(process.env.NODE_ENV != 'production'){
   apiUrl = 'http://api.bn.local/';
    mode = 'development';

    cdnApi = {
        'ru': 'http://api.bn.local/ru',
        'en': 'http://api.bn.local/en',
        'fr': 'http://api.bn.local/fr'
    };

}else{
    apiUrl = 'https://a.baikalnatu.re/';
    mode = 'production';

    cdnApi = {
        'ru': 'https://a.baikalnatu.re/ru',
        'en': 'https://a.baikalnatu.re/en',
        'fr': 'https://a.baikalnatu.re/fr'
    };

}

if(process.env.NODE_API == 'cdn'){
    mode = 'development';
}else{
    mode = 'production';
}



let isCDN = (process.env.API_CDN)?true:false;

function getApiUrl(lang) {

        return cdnApi[lang];

}



export function setMapHeight(height) {
    return {
        type: SET_MAP_HEIGHT,
        payload: height
    }
}

export function setMap(map) {
    return {
        type: SET_MAP,
        payload: map
    }
}
export function closeDepartureTooltip() {
    return {
        type: CLOSE_DEPARTURE_TOOLTIP
    }
}

export function setRouteDraw(draw) {
    return {
        type: SET_ROUTE_DRAW,
        payload: draw
    }
}

export function openReview(index) {
    return {
        type: OPEN_REVIEW,
        payload: index
    }
}


export function openReviewAnswer(index) {
    return {
        type: OPEN_REVIEW_ANSWER,
        payload: index
    }
}

export function toggleReviewRate(index) {
    return {
        type: TOGGLE_REVIEW_RATE,
        payload: index
    }
}

export function openReviews(index) {
    return {
        type: OPEN_REVIEWS,
        payload: index
    }
}

export function selectTab(index, stopIndication) {
    return {
        type: SELECT_TAB,
        payload: {index: index, stopIndication: stopIndication}
    }
}

export function setMapConfig(map) {
    return {
        type: SET_MAP_CONFIG,
        payload: map
    }
}

export function setMapFilter(params) {
    return {
        type: SET_MAP_FILTER,
        payload: params
    }
}

export function moreObjects(props) {
    return {
        type: MORE_OBJECTS,
        payload: props
    }
}


export function nextTour() {
    return {
        type: NEXT_TOUR
    }
}


export function prevDay() {
    return {
        type: PREV_DAY
    }
}
export function clearRoute() {
    return {
        type: CLEAR_ROUTE
    }
}

export function selectReviewsLang() {
    return {
        type: SELECT_REVIEWS_LANG
    }
}

export function selectDay(index) {
    return {
        type: SELECT_DAY,
        payload: index
    }
}


export function toggleDay(index) {
    return {
        type: TOGGLE_DAY,
        payload: index
    }
}


export function toggleDescription() {
    return {
        type: TOGGLE_DESCRIPTION
    }
}


export function setScroll(scroll) {
    return {
        type: SET_SCROLL,
        payload: scroll
    }
}


export function setViewDayPhoto(visible) {
    return {
        type: SET_DAY_PHOTO_VISIBLE,
        payload: visible
    }
}

export function hoverDay(index) {
    return {
        type: HOVER_DAY,
        payload: index
    }
}

export function toggleViewPhoto() {
    return {
        type: TOGGLE_VIEW_PHOTO
    }
}

export function selectMapPhoto(photo, index) {
    return {
        type: SELECT_MAP_PHOTO,
        payload: {photo: photo, index: index}
    }
}

export function nextMapPhoto(photo) {
    return {
        type: NEXT_MAP_PHOTO,
        payload: photo
    }
}

export function prevMapPhoto(photo) {
    return {
        type: PREV_MAP_PHOTO,
        payload: photo
    }
}

export function nextDay() {
    return {
        type: NEXT_DAY
    }
}


export function prevTour() {
    return {
        type: PREV_TOUR
    }
}


export function toggleCategories() {
    return {
        type: TOGGLE_CATEGORIES
    }
}

export function toggleMapFilter() {
    return {
        type: TOGGLE_MAP_FILTER
    }
}


export function toggleDeparture(departure) {
    return {
        type: TOGGLE_DEPARTURE,
        payload: departure
    }
}


export function selectDeparture(departure) {
    return {
        type: SELECT_DEPARTURE,
        payload: departure
    }
}



export function setCenter(center) {
    return {
        type: SET_CENTER,
        payload: center

    };
}

export function setZoom(zoom) {
    return {
        type: SET_ZOOM,
        payload: zoom
    };
}



export function testLang(lang){
    //console.log(lang);
}


export function getLang(){
    return (dispatch, getState) => {
        let state = getState();
        return dispatch(testLang(state.user.lang));
    };
}


export function loadTours(urlParam, lang) {
    return {
        type: TOURS_GET,
        promise: request.get(getApiUrl(lang) + `/tour`)
    }
}





export function fetchTours(urlParam) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadTours(urlParam, lang));
    }
}



export function loadFeaturedTours(urlParam, lang) {
    return {
        type: FEATURED_TOURS_GET,
        promise: request.get(getApiUrl(lang) + `/tour/featured`)
    }
}


export function fetchFeaturedTours(urlParam) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadFeaturedTours(urlParam, lang));
    }
}


function shouldFetchTours(state, urlParam) {
    const tours = state.tours.list;
    if (!tours) {
        return true;
    } else if (tours.isFetching) {
        return false;
    } else {
        return tours.didInvalidate;
    }
}

export function fetchToursIfNeeded(urlParam) {
    return (dispatch, getState) => {
        if (shouldFetchTours(getState(), urlParam)) {
            return dispatch(fetchTours(urlParam));
        }
    };
}


export function loadDestination(urlParam, lang) {
    return {
        type: DESTINATION_GET,
        promise: request.get(getApiUrl(lang) + `/destination/` + urlParam)
    }
}



export function fetchDestination(urlParam) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadDestination(urlParam, lang));
    }
}


export function fetchPromo(urlParam) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadPromo(urlParam, lang));
    }
}

export function loadPromo(urlParam, lang) {
    return {
        type: PROMO_GET,
        promise: request.get(getApiUrl(lang) + `/promo/page/` + urlParam)
    }
}

    
export function loadLandmark(urlParam, lang) {
    return {
        type: LANDMARK_GET,
        promise: request.get(getApiUrl(lang) + '/cms/landmark/slug/' + urlParam)
    }
}


export function fetchLandmark(urlParam) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadLandmark(urlParam, lang));
    }
}




export function loadLandmarks(lang, page) {
    return {
        type: LANDMARKS_GET,
        promise: request.get(getApiUrl(lang) + '/cms/landmark' + (page?'?page='+page:''))
    }
}


export function fetchLandmarks(page) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadLandmarks(lang, page));
    }
}




export function loadHotels(lang, page) {
    return {
        type: HOTELS_GET,
        promise: request.get(getApiUrl(lang) + '/cms/landmark' + (page?'?page='+page:''))
    }
}


export function fetchHotels(page) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadHotels(lang, page));
    }
}



export function loadHotel(urlParam, lang) {
    return {
        type: HOTEL_GET,
        promise: request.get(getApiUrl(lang) + '/cms/hotel/' + urlParam)
    }
}


export function fetchHotel(urlParam) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadHotel(urlParam, lang));
    }
}


export function selectPage(urlParam) {
    return {
        type: SELECT_PAGE,
        payload: urlParam
    }
}


export function loadPage(urlParam, lang) {
    return {
        type: PAGE_GET,
        promise: request.get(getApiUrl(lang) + '/cms/page/' + urlParam),
        payload: urlParam
    }
}


export function fetchPage(urlParam) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadPage(urlParam, lang));
    }
}


function shouldFetchDestination(state, urlParam) {
    const destination = state.tours.destination;
    if (!destination) {
        return true;
    } else if (destination.isFetching) {
        return false;
    } else {
        return destination.didInvalidate;
    }
}

export function fetchDestinationIfNeeded(urlParam) {
    return (dispatch, getState) => {
        if (shouldFetchDestination(getState(), urlParam)) {
            return dispatch(fetchDestination(urlParam));
        }
    };
}



export function undo() {
    return (dispatch, getState) => {
        dispatch(ActionCreators.undo());
    };
}


export function loadServiceGallery(urlParam, lang, index, serviceIndex) {
    return {
        type: SERVICE_GALLERY_GET,
        promise: request.get(getApiUrl(lang) + `/gallery/` + urlParam),
        payload: {index: index, serviceIndex: serviceIndex}
    }
}


export function fetchServiceGallery(urlParam, index, serviceIndex) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadServiceGallery(urlParam, lang, index, serviceIndex));
    }
}




export function loadGallery(urlParam, lang) {
    return {
        type: GALLERY_GET,
        promise: request.get(getApiUrl(lang) + `/gallery/` + urlParam),
        payload: urlParam,

    }
}


export function fetchGallery(urlParam) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadGallery(urlParam, lang));
    }
}



export function selectPhoto(index) {
    //console.log(index);
    return {
        type: SELECT_PHOTO,
        payload: index
    }
}


export function swipeGallery(delta) {
    //console.log(index);
    return {
        type: SWIPE_GALLERY,
        payload: delta
    }
}


export function playVideo(index) {
    //console.log(index);
    return {
        type: PLAY_VIDEO,
        payload: index
    }
}


function shouldFetchGallery(state, urlParam) {
    const gallery = state.tours.gallery;
    return !gallery.isFetching;
}

export function fetchGalleryIfNeeded(urlParam) {
    //console.log('fetchGalleryIfNeeded');
    return (dispatch, getState) => {

        //console.log(shouldFetchGallery(getState(), urlParam));
        if (shouldFetchGallery(getState(), urlParam)) {
            return dispatch(fetchGallery(urlParam));
        }
    };
}



export function setBoundedObjects(objects) {
    return {
        type: SET_BOUNDED_OBJECTS,
        payload: objects
    }
}



export function fetchPoints(urlParam, page) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadPoints(urlParam, page, lang));
    }
}

export function loadPoints(urlParam, page, lang) {
    let param;
    if (!urlParam) {
        param = 2;
    } else {
        param = urlParam;
    }
    //console.log(apiUrl + lang + `/geo/point/` + param + ((page)?'?page='+page:''));
    return {
        type: POINTS_GET,
        promise: request.get(getApiUrl(lang) + `/geo/point/` + param + ((page)?'?page='+page:''))
    }
}


function shouldFetchPoints(state, urlParam, page) {


    const points = state.tours.points;
    if (!points.isFetching && points.headers && points.headers.page != page) {
        return true;
    } else {
        return false;
    }
}

export function fetchPointsIfNeeded(urlParam, page) {
    return (dispatch, getState) => {
        if (shouldFetchPoints(getState(), urlParam, page)) {
            return dispatch(fetchPoints(urlParam, page));
        }
    };
}

export function loadDestinations(urlParam, lang) {
    return {
        type: DESTINATIONS_GET,
        promise: request.get(getApiUrl(lang) + `/destination`)
    }
}

export function fetchDestinations(urlParam) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadDestinations(urlParam, lang));
    }
}



export function loadTypes(urlParam, lang) {
    return {
        type: TYPES_GET,
        promise: request.get(getApiUrl(lang) + `/tour/type`)
    }
}


export function loadLocations() {
    return {
        type: LOCATIONS_GET,
        promise: request.get(apiUrl + `geo/location`)
    }
}


export function setLocation(location) {
    return {
        type: SET_LOCATION,
        payload: location
    }
}

export function fetchTypes(urlParam) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadTypes(urlParam, lang));
    }
}



export function loadActivities(urlParam, lang) {
    //console.log(99999999);
    return {
        type: ACTIVITIES_GET,
        promise: request.get(getApiUrl(lang) + `/tour/activity`)
    }
}

export function fetchActivities(urlParam) {
    //console.log(123123123432);
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadActivities(urlParam, lang));
    }
}



function shouldFetchDestinations(state, urlParam) {
    const destinations = state.tours.destinations;
    if (!destinations) {
        return true;
    } else if (destinations.isFetching) {
        return false;
    } else {
        return destinations.didInvalidate;
    }
}

export function fetchDestinationsIfNeeded(urlParam) {
    return (dispatch, getState) => {
        if (shouldFetchDestinations(getState(), urlParam)) {
            return dispatch(fetchDestinations(urlParam));
        }
    };
}



export function selectTour( tour ) {
    return {
        type: SELECT_MAP_TOUR,
        payload: tour
    }
}


export function selectMapTour( tour ) {
    return {
        type: SELECT_MAP_TOUR,
        payload: tour
    }
}

export function activateMap( active ) {
    return {
        type: ACTIVATE_MAP,
        payload: active
    }
}


export function fixedMap( fixed ) {
    return {
        type: FIXED_MAP,
        payload: fixed
    }
}


export function selectDestination( destination ) {
    return {
        type: SELECT_DESTINATION,
        payload: destination
    }
}


export function selectMainDestination( destination ) {
    return {
        type: SELECT_MAIN_DESTINATION,
        payload: destination
    }
}


export function selectType( type ) {
    return {
        type: SELECT_TYPE,
        payload: type
    }
}

export function selectMainType( type ) {
    return {
        type: SELECT_MAIN_TYPE,
        payload: type
    }
}

export function selectActivity( activity ) {
    return {
        type: SELECT_ACTIVITY,
        payload: activity
    }
}


export function selectMonth( month ) {
    return {
        type: SELECT_MONTH,
        payload: month
    }
}

export function selectSeason( months ) {
    return {
        type: SELECT_SEASON,
        payload: months
    }
}

export function selectLandmark ( landmark ) {
    return {
        type: SELECT_LANDMARK,
        payload: landmark
    }
}

export function loadPosts(urlParam, lang, isArchived) {
    return {
        type: TOUR_GET,
        promise: request.get(getApiUrl(lang) + `/tour/` + urlParam),
        payload: {urlParam: urlParam, isArchived: isArchived?true:false}
    }
}


export function fetchPosts(urlParam) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadPosts(urlParam, lang));
    }
}



export function loadReviews(urlParam, lang, page, reviewsLang) {

    return {
        type: REVIEWS_GET,
        promise: request.get(getApiUrl(lang) + '/tour/' + urlParam + '/review' + (reviewsLang?"/"+reviewsLang:"") + '?per-page=5&page=' + (page?page:1)),
        payload: urlParam,
        lang: reviewsLang
    }
}


export function fetchReviews(urlParam, page, reviewsLang) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadReviews(urlParam, lang, page, reviewsLang));
    }
}



export function loadAllReviews(page, lang, reviewsLang) {

    return {
        type: ALL_REVIEWS_GET,
        promise: request.get(getApiUrl(lang) + '/review' + (reviewsLang?"/"+reviewsLang:"") + '?per-page=20&page=' + (page?page:1)),
        payload: page,
        lang: reviewsLang
    }
}


export function fetchAllReviews(page, reviewsLang) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadAllReviews(page, lang, reviewsLang));
    }
}





export function loadToursSearch(params, lang) {

    return {
        type: TOURS_SEARCH,
        promise: request.get(getApiUrl(lang) + '/search/tour', {params: params})
    }
}


export function toursSearch(params) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        if (!params) {
            let params = getState().tours.mapFilterParams;
        }
        let paramsLength = 0;

        //console.log(params);
        for (let key in params) {
            if (params[key]) paramsLength++;
        }
        if (paramsLength) {
            return dispatch(loadToursSearch(params, lang));
        } else{
            return dispatch(loadTours('', lang));
        }
    }
}




export function loadToursSearchByMode(mode, value, lang) {

    return {
        type: TOURS_SEARCH_BY_MODE,
        payload: mode,
        promise: request.get(getApiUrl(lang) + '/tour/'+mode+'/' + value)
    }
}


export function toursSearchByMode(mode, value) {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadToursSearchByMode(mode, value, lang));
    }
}


export function loadTourMenu(lang) {

    return {
        type: TOUR_MENU_GET,
        promise: request.get(getApiUrl(lang) + '/tour/menu')
    }
}


export function getTourMenu() {
    return (dispatch, getState) => {
        let lang = getState().user.lang;
        return dispatch(loadTourMenu(lang));
    }
}


function shouldFetchPosts(state, tour) {
    const posts = state.postsByTour;
    if (!posts) {
        return true;
    } else if (posts.isFetching) {
        return false;
    } else {
        return posts.didInvalidate;
    }
}

export function fetchPostsIfNeeded(tour, urlParam) {
    //console.info('urlParam', urlParam);
    return (dispatch, getState) => {
        return dispatch(fetchPosts(urlParam, tour));
    };
}


// WEBPACK FOOTER //
// ./src/common/actions/tours.js